import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取分类
export const getTypes = async (params: object) => {
  return await POST({
    url: Api.getTypes,
    params: {
      ...params
    },
    showError: false
  })
}
// 获取收支明细信息
export const getTransactionsData = async (params: object) => {
  return await POSTFORM({
    url: Api.getTransactionsData,
    data: params.formData,
    showError: false
  })
}
export const queryCourierServiceFee = async (params: object) => {
  return await POST({
    url: Api.queryCourierServiceFee,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      resourceKey: 'payment/service/CourierSettlementConfigTradeFacade/queryCourierServiceFee'
    },
    params: {
      ...params
    },
    showError: false
  })
}
